import React from "react";
import constant from "../../constants";

export const OrderStatusBadge = ({ status, className = "", size = "md" }) => {
  const normalizedStatus = String(status || "").toLowerCase();

  const getStatusConfig = () => {
    switch (normalizedStatus) {
      case "approved":
      case "approve":
        return {
          label: constant.statusesTranslate?.approved || "อนุมัติ",
          bg: "bg-emerald-100 text-emerald-800 border-emerald-300",
          dot: "bg-emerald-600",
        };
      case "paid":
        return {
          label: constant.statusesTranslate?.paid || "รออนุมัติ",
          bg: "bg-sky-100 text-sky-800 border-sky-300",
          dot: "bg-sky-600",
        };
      case "pending":
        return {
          label: constant.statusesTranslate?.pending || "รอชำระเงิน",
          bg: "bg-amber-100 text-amber-900 border-amber-300",
          dot: "bg-amber-600",
        };
      case "canceled":
      case "cancel":
      case "rejected":
      case "reject":
        return {
          label: constant.statusesTranslate?.canceled || "ยกเลิก",
          bg: "bg-rose-100 text-rose-800 border-rose-300",
          dot: "bg-rose-600",
        };
      case "expired":
        return {
          label: constant.statusesTranslate?.expired || "หมดอายุ",
          bg: "bg-gray-100 text-gray-700 border-gray-300",
          dot: "bg-gray-500",
        };
      default:
        return {
          label: constant.statusesTranslate?.[normalizedStatus] || status || "-",
          bg: "bg-gray-100 text-gray-700 border-gray-300",
          dot: "bg-gray-400",
        };
    }
  };

  const config = getStatusConfig();
  const sizeClasses =
    size === "sm"
      ? "px-2.5 py-1 text-xs gap-1.5"
      : size === "lg"
      ? "px-4 py-2 text-sm gap-2"
      : "px-3 py-1.5 text-xs gap-1.5";

  return (
    <span
      className={`inline-flex items-center justify-center font-bold rounded-md border shadow-xs transition-all select-none ${sizeClasses} ${config.bg} ${className}`}
    >
      <span className={`w-2 h-2 rounded-full ${config.dot}`} />
      <span>{config.label}</span>
    </span>
  );
};

export default OrderStatusBadge;
